import { useTheme } from '@/contexts/ThemeContext';

interface CaseReportLocationProps {
    report: any;
    isReadOnly?: boolean;
    onReportChange?: (report: any) => void;
    onViewMap?: () => void;
    onLocationBlur?: () => void;
}

export function CaseReportLocation({
    report,
    isReadOnly = false,
    onReportChange,
    onViewMap,
    onLocationBlur,
}: CaseReportLocationProps) {
    const { theme } = useTheme();

    const handleFieldChange = (field: string, value: string) => {
        if (onReportChange) {
            onReportChange({ ...report, [field]: value });
        }
    };

    return (
        <div className={'case-report-details-panel' + (theme ? ' ' + theme : '')}>
            <div className="panel-header">
                Incident Location
                {report.callLocFormattedAddress && (
                    <button
                        type="button"
                        className="btn-header-link"
                        onClick={() => onViewMap?.()}
                    >
                        View Map
                    </button>
                )}
            </div>
            <div className="panel-body">
                {/* Address/Intersection */}
                <div className="form-row">
                    <div className="form-group form-group-full">
                        <label className="field-label">Address/Intersection</label>
                        <input
                            type="text"
                            className="form-input"
                            id="txtValidateableLocation"
                            value={report.callLocFormattedAddress || ''}
                            disabled={isReadOnly}
                            onChange={(e) => handleFieldChange('callLocFormattedAddress', e.target.value)}
                            onBlur={() => onLocationBlur?.()}
                        />
                    </div>
                </div>

                {/* Apt/Suite & Building */}
                <div className="form-row">
                    <div className="form-group">
                        <label className="field-label">Apt/Suite</label>
                        <input
                            type="text"
                            className="form-input"
                            value={report.callLocAddress2 || ''}
                            disabled={isReadOnly}
                            onChange={(e) => handleFieldChange('callLocAddress2', e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <label className="field-label">Building</label>
                        <input
                            type="text"
                            className="form-input"
                            value={report.callLocName || ''}
                            disabled={isReadOnly}
                            onChange={(e) => handleFieldChange('callLocName', e.target.value)}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

(window as any).CaseReportLocationReact = CaseReportLocation;
